export function downloadInvoice(order) {
  const date = new Date(order.created_at).toLocaleDateString('en-IN', {
    day: '2-digit', month: 'long', year: 'numeric',
  });
  const invoiceNo = `INV-${order.id.substring(0, 8).toUpperCase()}`;
  const itemsRows = (order.items || []).map(item => {
    const qty = item.qty || item.quantity || 1;
    return `<tr>
      <td>${item.name}</td>
      <td style="text-align:center">${qty}</td>
      <td style="text-align:right">&#8377;${Number(item.price).toLocaleString('en-IN')}</td>
      <td style="text-align:right">&#8377;${(item.price * qty).toLocaleString('en-IN')}</td>
    </tr>`;
  }).join('');

  const total = Number(order.total);
  const productValue = Number(order.subtotal || order.total);
  const shippingCost = total - productValue;
  const basePrice = Math.round(productValue / 1.18 * 100) / 100;
  const gstAmount = Math.round((productValue - basePrice) * 100) / 100;

  const html = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<title>${invoiceNo} - Kiane Foods</title>
<style>
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:'Segoe UI',Arial,sans-serif;color:#222;background:#fff;padding:40px}
  .hdr{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:32px}
  .brand{font-size:28px;font-weight:800;color:#b5451b;letter-spacing:-0.5px}
  .brand-tag{font-size:12px;color:#888;margin-top:3px}
  .brand-gstin{font-size:11px;color:#b5451b;font-weight:600;margin-top:4px;letter-spacing:0.5px}
  .inv-meta{text-align:right}
  .inv-meta h2{font-size:22px;color:#444;font-weight:700}
  .inv-meta p{font-size:13px;color:#666;margin-top:4px}
  hr{border:none;border-top:2px solid #f0e8e0;margin:20px 0}
  .info-grid{display:grid;grid-template-columns:1fr 1fr;gap:24px;margin-bottom:28px}
  .info-block h4{font-size:11px;text-transform:uppercase;letter-spacing:1px;color:#b5451b;margin-bottom:8px}
  .info-block p{font-size:13px;color:#333;line-height:1.7}
  table.items{width:100%;border-collapse:collapse;margin-bottom:12px}
  .items thead th{background:#b5451b;color:#fff;padding:9px 12px;font-size:12px;text-align:left}
  .items thead th:not(:first-child){text-align:center}
  .items thead th:last-child{text-align:right}
  .items tbody tr:nth-child(even){background:#fdf5f0}
  .items tbody td{padding:9px 12px;font-size:13px;border-bottom:1px solid #f0e8e0}
  .items tbody td:not(:first-child){text-align:center}
  .items tbody td:last-child{text-align:right}
  .totals{display:flex;justify-content:flex-end;margin-top:4px}
  .totals-box{min-width:220px;border-collapse:collapse}
  .totals-box td{padding:6px 12px;font-size:14px}
  .totals-box .grand td{font-weight:700;font-size:16px;border-top:2px solid #b5451b;padding-top:10px}
  .pay-info{background:#fdf5f0;border-left:4px solid #b5451b;padding:12px 16px;margin-top:28px;border-radius:4px;font-size:12px;color:#555;line-height:1.9}
  .footer{text-align:center;margin-top:48px;font-size:12px;color:#aaa}
  @media print{body{padding:20px}@page{margin:15mm}}
</style>
</head>
<body>
<div class="hdr">
  <div>
    <div class="brand">Kiane Foods</div>
    <div class="brand-gstin">GSTIN: 03BDKPG6123N1ZJ</div>
  </div>
  <div class="inv-meta">
    <h2>INVOICE</h2>
    <p>${invoiceNo}</p>
    <p>Date: ${date}</p>
  </div>
</div>
<hr>
<div class="info-grid">
  <div class="info-block">
    <h4>Billed To</h4>
    <p><strong>${order.customer_name}</strong><br>${order.customer_phone}${order.customer_email ? '<br>' + order.customer_email : ''}</p>
  </div>
  <div class="info-block">
    <h4>Shipping Address</h4>
    <p>${order.address || '&#8212;'}<br>${[order.city, order.state].filter(Boolean).join(', ')}${order.pincode ? ' &#8211; ' + order.pincode : ''}</p>
  </div>
</div>
<table class="items">
  <thead><tr><th>Item</th><th>Qty</th><th>Unit Price</th><th>Amount</th></tr></thead>
  <tbody>${itemsRows}</tbody>
</table>
<div class="totals">
  <table class="totals-box">
    <tr><td>Taxable Value (excl. GST)</td><td style="text-align:right">&#8377;${basePrice.toLocaleString('en-IN', {minimumFractionDigits:2, maximumFractionDigits:2})}</td></tr>
    <tr><td>CGST @ 9%</td><td style="text-align:right">&#8377;${(gstAmount/2).toLocaleString('en-IN', {minimumFractionDigits:2, maximumFractionDigits:2})}</td></tr>
    <tr><td>SGST @ 9%</td><td style="text-align:right">&#8377;${(gstAmount/2).toLocaleString('en-IN', {minimumFractionDigits:2, maximumFractionDigits:2})}</td></tr>
    <tr><td>Shipping</td><td style="text-align:right">${shippingCost > 0 ? '&#8377;' + shippingCost.toLocaleString('en-IN') : 'Free'}</td></tr>
    <tr class="grand"><td>Total (incl. GST)</td><td style="text-align:right">&#8377;${total.toLocaleString('en-IN')}</td></tr>
  </table>
</div>
<div class="pay-info">
  <strong>Payment Status:</strong> Paid
  ${order.gateway_payment_id ? '&nbsp;|&nbsp;<br><strong>Payment Reference:</strong> ' + order.gateway_payment_id : ''}
</div>
<div class="footer">Thank you for your order! &nbsp;|&nbsp; Kiane Foods &nbsp;|&nbsp; For queries, contact us on Instagram @kiane.yumm</div>
<script>window.onload=function(){window.print()}</script>
</body>
</html>`;

  const win = window.open('', '_blank');
  if (win) { win.document.write(html); win.document.close(); }
}
